import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import CardSummary from '../AdyenPaymentCardSummary.js';

const BancontactSummary = (props)=>/*#__PURE__*/ React.createElement(CardSummary, swcHelpers.extends({}, props))
;

export { BancontactSummary as default };
//# sourceMappingURL=BancontactSummary.js.map
